module.exports = __webpack_public_path__ + "media/bg.5bd53452.mp4";